import {
    Operator,
    OperatorCanvasToolboxType,
    OperatorFlags,
    OperatorPanelComponentType,
    OperatorProcessingHints,
} from "@app/textures/texture-editor/operator-stack/operators/abstract-base/operator"
import {OperatorBase} from "@app/textures/texture-editor/operator-stack/operators/abstract-base/operator-base"
import {OperatorCallback} from "@app/textures/texture-editor/operator-stack/operators/abstract-base/operator-callback"
import {ImageOpNodeBag} from "@app/textures/texture-editor/operator-stack/image-op-system/helpers/image-op-node-bag"
import {AnyImageOpResultNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"

export class OperatorInitial extends OperatorBase<undefined> {
    // OperatorBase
    override readonly flags = new Set<OperatorFlags>(["is-internal", "no-clone", "apply-to-all-texture-types"])

    readonly panelComponentType?: OperatorPanelComponentType = undefined
    readonly canvasToolbox?: OperatorCanvasToolboxType = undefined

    readonly type = "operator-initial" as const

    constructor(callback: OperatorCallback) {
        super(callback, undefined)
    }

    // OperatorBase
    async clone(): Promise<Operator> {
        throw new Error("Not supported")
    }

    // OperatorBase
    override async createImageOpGraph(sourceImage: AnyImageOpResultNode, _hints: OperatorProcessingHints, _imageOpNodeBag: ImageOpNodeBag) {
        return sourceImage
    }
}
